import {
  ApiResponse,
  CreateCurriculumPayload,
  CreateCurriculumResponse,
} from "@twinkltech/curriculum-architect-domain-hooks";

import { IndividualNewCurriculumModal } from "./components/IndividualNewCurriculumModal/IndividualNewCurriculumModal";
import { SchoolNewCurriculumModal } from "./components/SchoolNewCurriculumModal/SchoolNewCurriculumModal";

export const NewCurriculumModal = ({
  isLoading,
  isSchoolAccount,
  onHandleSubmit,
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  isLoading: boolean;
  isSchoolAccount: boolean;
  onHandleSubmit: (params: {
    payload: CreateCurriculumPayload;
  }) => ApiResponse<CreateCurriculumResponse>;
}) => {
  return isSchoolAccount ? (
    <SchoolNewCurriculumModal
      isLoading={isLoading}
      open={open}
      setOpen={setOpen}
      onHandleSubmit={onHandleSubmit}
    />
  ) : (
    <IndividualNewCurriculumModal
      isLoading={isLoading}
      open={open}
      setOpen={setOpen}
      onHandleSubmit={onHandleSubmit}
    />
  );
};
